import ArticleCard from "@/components/base/ArticleCard";
import { getLatestArticles } from "@/mocks/articles";

export default function HotArticles() {
  const latestArticles = getLatestArticles(9);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="text-3xl md:text-4xl font-heading font-light text-foreground-900">
            最新爆料
          </h2>
          <p className="text-sm text-foreground-500 mt-1">
            每日黑料吃瓜网实时更新，网红塌房现场直击
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {latestArticles.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>

        {latestArticles.length === 0 && (
          <div className="text-center py-20">
            <i className="ri-inbox-line text-4xl text-foreground-300 w-10 h-10 flex items-center justify-center mx-auto mb-3"></i>
            <p className="text-foreground-500">暂无爆料内容</p>
          </div>
        )}
      </div>
    </section>
  );
}